window.CampaignsPage={
    windowHeight: $(window).height(),
    isLoading: false,
    init_offset: 21,
    per_page: 9,
    current_offset: 0,
    finishedPagination: false,
    nextProjectsPage(){
        let self=CampaignsPage;
        return new Promise((res,rej) => {
            let sendData={};
            if((typeof ajaxSendData).toLowerCase() == "object" ) {
                $.each(ajaxSendData,(key,value) => {
                    sendData[key]=value;
                });
            }
            sendData.limit=self.per_page;
            sendData.step=self.init_offset+self.current_offset;
            $.ajax({
                method: "POST",
                data: sendData,
                url: urls.load_campaigns,
                success: data => {
                    if(data.length==0){
                        $(window).unbind('scroll',CampaignsPage.scrollWatch);
                    }
                    self.current_offset+=self.per_page;
                    res(data);
                },
                error: err => {
                    rej(err.message);
                }
            })
        });
    },
    scrollWatch(){
        let self=CampaignsPage;
        if(!self.isLoading) {
            let offsetTop = $(window).scrollTop(),
                spinner = $('#spinnerWrapper').first(),
                spinnerOffsetTop = spinner.offset().top;
            if (spinnerOffsetTop >= (offsetTop) && spinnerOffsetTop <= (offsetTop + self.windowHeight)) {
                spinner.css({
                    visibility: "visible"
                });
                self.isLoading=true;
                self
                    .nextProjectsPage()
                    .then(data => {
                        $('.projectsPlace:first').append(data);
                        asyncImageComponent.load();
                        asyncImageComponent.lazyLoadAbstract();
                        self.isLoading=false;
                        spinner.css({
                            visibility: "hidden"
                        });
                    })
                    .catch(err => {
                        alert(err);
                    });
            }
        }
    },
    changeProjectTab: (url,wasSearch,mouseWhich) => {
        url=url.replace(/\/\//g,"/");
        if (!wasSearch) {
            if(mouseWhich==1) {
                window.location.href = url;
            }else{
                window.open(url);
            }
        }else{
            // POST
            if(mouseWhich==2) $('#formBusca').attr("target", "_blank");

            $('#formBusca').attr('action',(url+'/palavra').toString().replace(/\/\//g,'/'));
            $('#formBusca').find('[name=key_words]').val(ajaxSendData.keywords);
            /*
                TODO Add hidden input to get this keywords
             */
            $('#formBusca').submit();
        }
    },
    validaBusca : (e,$form,sBuscaPor) => {
        e.preventDefault();
        sBuscaPor = $.trim(sBuscaPor);

        let bErro = false;
        if (sBuscaPor.length==0) {
            bErro = "Nenhuma palavra foi informada";
        }
        else {
            if (sBuscaPor.length < 3) {
                bErro = "Digite ao menos 3 letras";
            }
        }
        if (!bErro) {
            $form.unbind('submit');
            $form.submit();
        }
        else{
            $form.find(".alert > .alert-message").html(
                bErro
            );
            let $row=$form.find('.alert').parents('.row').first();
            $row.slideDown(() => {
                setTimeout(() => {
                    $row.slideUp();
                },3000);
            });
        }
    },
    toggleFilter: (on) => {
        if(on){
            let $w=$(window);
            $('.project-options').css({
                width: $w.width(),
                height: $w.height()
            });
            $('.project-options').fadeIn(500);
        }else{
            $('.project-options').fadeOut(500);
        }
    },
    load(){
        if($("#campaign-page").length>0){
            $(window).scroll(CampaignsPage.scrollWatch);
            $(".pick-project > a[data-url][data-was-search]").on('mousedown',(e) => {
                if([1,2].indexOf(e.which)>-1) {
                    e.preventDefault();
                    let $a=(e.target.tagName=="a")?$(e.target):$(e.target).parents('a').first();
                    if($a.length==1) CampaignsPage.changeProjectTab($a.data('url'),$a.data('was-search'),e.which);
                }
            });

            $("#formBusca,#formBuscaMobile").submit((e) => {
                CampaignsPage.validaBusca(e,$(e.target),$(e.target).find("[name=key_words]").val());
            });
            $("#magicword").click(() => {
               CampaignsPage.toggleFilter(true);
            });
            $('.close-it').click(() => {
                CampaignsPage.toggleFilter(false);
            });
            $('[name=key_words]').keyup((e) => {
                let $t=$(e.target);

                if($t.val().length>0){
                    $t.parent().find('.placeholder-search').hide();
                }else{
                    $t.parent().find('.placeholder-search').show();
                }
            });
        }
    }
};
CampaignsPage.load();